"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { departments: null };
    },
    onMount: function () {
        this.fetchDepartments();
    },
    fetchDepartments: async function () {
        try {
            const {error, message, results} = await Request('/department/list');
            if (error)
                console.log('Error Fetching Departments: ', message);
            this.state.departments = results || [];
        } catch (error) {
            console.log('Error Fetching Departments');
            this.state.departments = null;
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Departments/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    EmptyList_template = require("../../components/EmptyList.marko"),
    EmptyList_tag = marko_loadTag(EmptyList_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "px-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("cd168a"),
    marko_node0 = marko_createElement("br", null, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "card-body"
      },
    marko_attrs3 = {
        "class": "card-text overflow-hidden font-medium-4"
      },
    marko_attrs4 = {
        "class": "font-small-3 text-muted text-ellipsis mb-0"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out, { page, themeMode }) {
        if (state.departments == null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!state.departments.length) {
          EmptyList_tag({
              routeTo: "create_department"
            }, out, __component, "2");
        } else {
          out.be("div", marko_attrs0, "3", component);

          Row_tag({
              renderBody: function(out) {
                var $for$0 = 0;

                marko_forOf(state.departments, function({ departmentId, poster, name, description }, index) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  WSAdapt_tag({
                      qs: "col-lg-4 col-12",
                      hs: "col-lg-6 col-12",
                      class: "col-lg-4 col-md-6 col-12",
                      renderBody: function(out) {
                        route_link_tag({
                            href: "/department/" + departmentId,
                            class: "card item",
                            renderBody: function(out) {
                              out.be("div", marko_attrs1, "6" + $keyScope$0, component);

                              Row_tag({
                                  class: "no-gutters",
                                  col: [
                                      {
                                          class: "col-lg-3 col-sm-4 col-12",
                                          renderBody: function(out) {
                                            Image_tag({
                                                alt: name,
                                                src: poster,
                                                class: "h-100 w-100 rounded-left"
                                              }, out, __component, "9" + $keyScope$0);
                                          }
                                        },
                                      {
                                          class: "col-lg-9 col-sm-8 col-12",
                                          renderBody: function(out) {
                                            out.e("div", marko_attrs2, "11" + $keyScope$0, component, 2)
                                              .e("div", marko_attrs3, "12" + $keyScope$0, component, 1)
                                                .t(name, component)
                                              .e("div", marko_attrs4, "13" + $keyScope$0, component, 1)
                                                .t(description, component);
                                          }
                                        }
                                    ]
                                }, out, __component, "7" + $keyScope$0);

                              out.ee();
                            }
                          }, out, __component, "5" + $keyScope$0);
                      }
                    }, out, __component, departmentId);
                });
              }
            }, out, __component, "4");

          out.n(marko_node0, component);

          out.n(marko_node1, component);

          route_link_tag({
              href: "/create-department",
              class: "btn btn-primary btn-lg",
              renderBody: function(out) {
                Locale_tag({
                    text: "Add a Department"
                  }, out, __component, "17");
              }
            }, out, __component, "16");

          out.ee();
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
